export default __webpack_public_path__ + "static/zengo-c0bf35f913e66911bd6d3365cdf7b8fa.svg";